'use client';

import { useState } from 'react';

interface Company {
  name: string;
  url: string;
  logo: string;
}

function CompanyLogo({ company }: { company: Company }) {
  const [imgError, setImgError] = useState(false);

  return (
    <a
      href={company.url}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center justify-center px-6 py-3 bg-gray-50 rounded-lg border border-gray-200 hover:border-primary hover:shadow-sm transition-all duration-200"
      aria-label={`Visit ${company.name}`}
    >
      {!imgError ? (
        <img
          src={company.logo}
          alt={`${company.name} logo`}
          className="h-8 w-auto object-contain"
          onError={() => setImgError(true)}
        />
      ) : (
        <span className="text-sm font-medium text-gray-700">{company.name}</span>
      )}
    </a>
  );
}

export default function CompaniesWeWorkWith() {
  const companies: Company[] = [
    {
      name: 'Buzz Affiliates',
      url: 'https://www.buzzaffiliates.com/',
      logo: 'https://www.buzzaffiliates.com/wp-content/themes/buzzaffiliates/assets/images/logo.png',
    },
  ];

  return (
    <section className="py-10 bg-white border-t border-gray-100">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-sm font-semibold text-gray-500 uppercase tracking-widest mb-6">
          Companies We Work With
        </p>
        <div className="flex flex-wrap items-center justify-center gap-8">
          {companies.map((company) => (
            <CompanyLogo key={company.name} company={company} />
          ))}
        </div>
      </div>
    </section>
  );
}
